import { render, staticRenderFns } from "./join2.vue?vue&type=template&id=3000601c&scoped=true&"
import script from "./join2.vue?vue&type=script&lang=js&"
export * from "./join2.vue?vue&type=script&lang=js&"
import style0 from "./join2.vue?vue&type=style&index=0&id=3000601c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3000601c",
  null
  
)

export default component.exports